"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.essentialStatusOptions = exports.EssentialStatus = exports.deductibleTypeOptions = exports.DeductibleType = exports.deductibleRetentionNonApplicableOptions = exports.currencyEnabledDeductibleRetentionNonApplicable = exports.DeductibleRetentionNonApplicable = exports.deductibleRetentionOptions = exports.DeductibleRetention = exports.moneyOrPercentageOptions = exports.MoneyOrPercentageType = void 0;
const dsl_schema_api_1 = require("@newfront-insurance/dsl-schema-api");
var MoneyOrPercentageType;
(function (MoneyOrPercentageType) {
    MoneyOrPercentageType["MONETARY"] = "MONETARY";
    MoneyOrPercentageType["PERCENTAGE"] = "PERCENTAGE";
    MoneyOrPercentageType["NOT_APPLICABLE"] = "NOT_APPLICABLE";
})(MoneyOrPercentageType = exports.MoneyOrPercentageType || (exports.MoneyOrPercentageType = {}));
exports.moneyOrPercentageOptions = dsl_schema_api_1.valueToLabelRecordToOptions({
    [MoneyOrPercentageType.MONETARY]: 'Dollar amount',
    [MoneyOrPercentageType.PERCENTAGE]: 'Percentage',
    [MoneyOrPercentageType.NOT_APPLICABLE]: 'Not applicable',
});
var DeductibleRetention;
(function (DeductibleRetention) {
    DeductibleRetention["DEDUCTIBLE"] = "DEDUCTIBLE";
    DeductibleRetention["RETENTION"] = "RETENTION";
})(DeductibleRetention = exports.DeductibleRetention || (exports.DeductibleRetention = {}));
exports.deductibleRetentionOptions = dsl_schema_api_1.valueToLabelRecordToOptions({
    [DeductibleRetention.DEDUCTIBLE]: 'Deductible',
    [DeductibleRetention.RETENTION]: 'Retention',
});
var DeductibleRetentionNonApplicable;
(function (DeductibleRetentionNonApplicable) {
    DeductibleRetentionNonApplicable["DEDUCTIBLE"] = "DEDUCTIBLE";
    DeductibleRetentionNonApplicable["RETENTION"] = "RETENTION";
    DeductibleRetentionNonApplicable["NOT_APPLICABLE"] = "NOT_APPLICABLE";
})(DeductibleRetentionNonApplicable = exports.DeductibleRetentionNonApplicable || (exports.DeductibleRetentionNonApplicable = {}));
exports.currencyEnabledDeductibleRetentionNonApplicable = [
    DeductibleRetentionNonApplicable.DEDUCTIBLE,
    DeductibleRetentionNonApplicable.RETENTION,
];
exports.deductibleRetentionNonApplicableOptions = dsl_schema_api_1.valueToLabelRecordToOptions({
    [DeductibleRetentionNonApplicable.DEDUCTIBLE]: 'Deductible',
    [DeductibleRetentionNonApplicable.RETENTION]: 'Retention',
    [DeductibleRetentionNonApplicable.NOT_APPLICABLE]: 'Not Applicable',
});
var DeductibleType;
(function (DeductibleType) {
    DeductibleType["UNKNOWN"] = "UNKNOWN";
    DeductibleType["PER_CLAIM"] = "PER_CLAIM";
    DeductibleType["PER_OCCURRENCE"] = "PER_OCCURRENCE";
})(DeductibleType = exports.DeductibleType || (exports.DeductibleType = {}));
exports.deductibleTypeOptions = dsl_schema_api_1.valueToLabelRecordToOptions({
    [DeductibleType.PER_CLAIM]: 'Per claim',
    [DeductibleType.PER_OCCURRENCE]: 'Per occurrence',
    [DeductibleType.UNKNOWN]: 'Unknown',
});
var EssentialStatus;
(function (EssentialStatus) {
    EssentialStatus["EXCLUDED"] = "EXCLUDED";
    EssentialStatus["INCLUDED"] = "INCLUDED";
    EssentialStatus["LIMIT"] = "LIMIT";
    EssentialStatus["UNKNOWN"] = "UNKNOWN";
})(EssentialStatus = exports.EssentialStatus || (exports.EssentialStatus = {}));
exports.essentialStatusOptions = dsl_schema_api_1.valueToLabelRecordToOptions({
    [EssentialStatus.EXCLUDED]: 'Excluded',
    [EssentialStatus.INCLUDED]: 'Included',
    [EssentialStatus.LIMIT]: 'Limit',
    [EssentialStatus.UNKNOWN]: 'Unknown',
});
//# sourceMappingURL=common.js.map